/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { logAnalyticsEvent } from "common/analytics";
import AnalyticsEventName from "common/analytics/types/AnalyticsEventName";
import CircularProgress from "components/Progress/CircularProgress";
import useNotification from "common/hooks/useNotification";
import { NotificationType } from "common/types/Notification";
import { obtainDriverAppIDToken } from "common/util";
import { configurationSlice } from "store/slices/configuration";

const useClasses = makeStyles(() => ({
    tokenLoginContainer: {
        height: "100vh",
        width: "100vw",
    },
}));

export default function DriverAppLoginPage() {
    const navigate = useNavigate();
    const classes = useClasses();
    const { enqueueNotification } = useNotification();
    const dispatch = useDispatch();

    useEffect(() => {
        obtainDriverAppIDToken()
            .then((token) => {
                dispatch(configurationSlice.actions.setAuthToken(token));
                dispatch(configurationSlice.actions.setIsDriverApp(true));
                logAnalyticsEvent({
                    info: {
                        errorMessage: "",
                        flowName: "login",
                        flowPlatform: "driver_app",
                        isError: false,
                    },
                    name: AnalyticsEventName.UserAuthentication,
                });
            })
            .catch((error) => {
                logAnalyticsEvent({
                    info: {
                        errorMessage: error?.name,
                        flowName: "login",
                        flowPlatform: "driver_app",
                        isError: true,
                        payload: error?.message,
                    },
                    name: AnalyticsEventName.UserAuthentication,
                });

                enqueueNotification({
                    error,
                    message: (error as Error)?.message,
                    type: NotificationType.ERROR,
                });
                navigate("/");
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box
            className={classes.tokenLoginContainer}
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <CircularProgress />
        </Box>
    );
}
